import React from 'react';
import { Label } from '@/components/ui/label';
import { TagInputField } from '../fields/TagInputField';

interface ServiceAreasSectionProps {
  providerInfo: any;
  form?: any;
  setForm?: React.Dispatch<React.SetStateAction<any>>;
  saving?: boolean;
  readonly?: boolean;
}

export const ServiceAreasSection = ({
  providerInfo,
  form,
  setForm,
  saving = false,
  readonly = false,
}: ServiceAreasSectionProps) => {
  if (readonly) {
    return (
      <div className="space-y-6">
        <h3 className="text-lg font-semibold">Service Areas & Specialties</h3>
        <div className="grid gap-6">
          <div>
            <Label className="text-sm font-medium text-muted-foreground">States Served</Label>
            <div className="mt-2">
              {providerInfo.states_served && providerInfo.states_served.length > 0 ? (
                <div className="flex flex-wrap gap-2">
                  {providerInfo.states_served.map((state: string, index: number) => (
                    <span key={index} className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary/10 text-primary">
                      {state}
                    </span>
                  ))}
                </div>
              ) : (
                <span className="text-muted-foreground italic">Not set</span>
              )}
            </div>
          </div>
          <div>
            <Label className="text-sm font-medium text-muted-foreground">Industries Served</Label>
            <div className="mt-2">
              {providerInfo.industries_served && providerInfo.industries_served.length > 0 ? (
                <div className="flex flex-wrap gap-2">
                  {providerInfo.industries_served.map((industry: string, index: number) => (
                    <span key={index} className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-secondary/50 text-secondary-foreground">
                      {industry}
                    </span>
                  ))}
                </div>
              ) : (
                <span className="text-muted-foreground italic">Not set</span>
              )}
            </div>
          </div>
          <div>
            <Label className="text-sm font-medium text-muted-foreground">Specialties</Label>
            <div className="mt-2">
              {providerInfo.specialties && providerInfo.specialties.length > 0 ? (
                <div className="flex flex-wrap gap-2">
                  {providerInfo.specialties.map((specialty: string, index: number) => (
                    <span key={index} className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-accent/50 text-accent-foreground">
                      {specialty}
                    </span>
                  ))}
                </div>
              ) : (
                <span className="text-muted-foreground italic">Not set</span>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold">Service Areas & Specialties</h3>
      <div className="grid gap-6">
        <TagInputField
          label="States Served"
          fieldName="states_served"
          placeholder="e.g. CA, NY, TX"
          description="Enter state abbreviations where you provide services"
          form={form}
          setForm={setForm}
          disabled={saving}
        />
        <TagInputField
          label="Industries Served"
          fieldName="industries_served"
          placeholder="e.g. Healthcare, Manufacturing, Technology"
          description="Industries you specialize in serving"
          form={form}
          setForm={setForm}
          disabled={saving}
        />
        <TagInputField
          label="Specialties"
          fieldName="specialties"
          placeholder="e.g. Startup-friendly, Non-profit experience, High-risk industries"
          description="Your areas of specialization and expertise"
          form={form}
          setForm={setForm}
          disabled={saving}
        />
      </div>
    </div>
  );
};